import React from "react";
import {
  Button,
  IconButton,
  Typography,
} from "@material-ui/core";

import {
  FavoriteBorder,
  ShoppingCartOutlined,
} from "@material-ui/icons";
import { useHistory } from "react-router-dom";

export interface Product {
  category?: any;
  id: string | number;
  name: string;
  price: number;
  oldPrice?: number;
  image: string;
  categories: string[];
  sale?: boolean;
  description?: string;
  stock?: number;
}

interface ProductCardProps {
  product: Product;
  onAddToCart?: (product: Product) => void;
}

const ProductCard: React.FC<ProductCardProps> = ({
  product,
  onAddToCart,
}) => {
  const history = useHistory();

  const openProduct = () => {
    history.push(`/product/${product.id}`);
  };
  return (
    <div className="product-card">

      {/* Product Image */}
      <div className="product-image-wrapper">

        {product.sale && (
          <div className="sale-badge">
            Sale!
          </div>
        )}

        <IconButton className="wishlist-button">
          <FavoriteBorder />
        </IconButton>

        <img
          src={product.image}
          alt={product.name}
          className="product-image"
          onClick={openProduct}
        />

        <div className="product-hover">
          <Button
            variant="contained"
            className="add-cart-button"
            startIcon={
              <ShoppingCartOutlined />
            }
            onClick={() =>
              onAddToCart?.(product)
            }
          >
            Add to Cart
          </Button>
        </div>
      </div>

      {/* Product Information */}
      <div className="product-information">

        <Typography className="product-name">
          {product.name}
        </Typography>

        <div className="product-categories">
          {product.categories.map(
            (category, index) => (
              <React.Fragment
                key={`${product.id}-${category}`}
              >
                {index > 0 && " , "}

                <span>
                  {category}
                </span>
              </React.Fragment>
            )
          )}
        </div>

        <div className="product-price">

          <Typography component="span">
            ₹{product.price.toFixed(2)}
          </Typography>

          {product.oldPrice && (
            <Typography
              component="span"
              className="old-price"
            >
              ₹{product.oldPrice.toFixed(2)}
            </Typography>
          )}

        </div>

      </div>
    </div>
  );
};

export default ProductCard;